import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=1b0ebaeb&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=1b0ebaeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ebaeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b0ebaeb')) {
      api.createRecord('1b0ebaeb', component.options)
    } else {
      api.reload('1b0ebaeb', component.options)
    }
    module.hot.accept("./Service.vue?vue&type=template&id=1b0ebaeb&scoped=true&", function () {
      api.rerender('1b0ebaeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Service.vue"
export default component.exports